import type { AdPartner } from 'client/js/main/types/adPartnerTypes';

const ADS_CUSTOM_PARTNER_PREFIX = 'a_custom_';
const OTT_CUSTOM_PARTNER_PREFIX = 'a_custom_ott_';

type PartnerType = Pick<AdPartner, 'machine_name'>;

class CustomPartnerService {
  static isCustomPartner(partner: PartnerType): boolean {
    return this.isCustomAdsPartner(partner) || this.isCustomOttPartner(partner);
  }

  static isCustomAdsPartner(partner: PartnerType): boolean {
    return partner.machine_name.startsWith(ADS_CUSTOM_PARTNER_PREFIX) && !this.isCustomOttPartner(partner);
  }

  static isCustomOttPartner(partner: PartnerType): boolean {
    return partner.machine_name.startsWith(OTT_CUSTOM_PARTNER_PREFIX);
  }
}

export default CustomPartnerService;
